import { _ } from "../../vendor";

import InboomaBaseAsyncCollection from "./InboomaBaseAsyncCollection";
import Reservation from "../models/Reservation";

export default InboomaBaseAsyncCollection.extend({
  collectionName: "reservations",
  model: Reservation,
  url: "/reservations",

  _pagination: {
    current_page: 0,
    sort: "begin",
    sortDirection: "desc",
    has_next_page: false,
    has_prev_page: false,
    count: 0, // not relevant; response total entities count
    limit: 40,
  },
});
